import { useCallback } from 'react';
import JSB from '@bridge/sharee';
import { useAtomValue } from 'jotai';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { useFetch } from './use-fetch';
import { HttpMethod } from './fetch';

export class SubmitEmailError extends Error {}

/**
 * @return 发送验证码的方法
 */
export default function useSubmitEmail(): (email: string) => Promise<void> {
  const { isInApp } = useAtomValue($UserAgent);
  const fetch = useFetch();

  const submitEmail = useCallback(
    async (email: string) => {
      if (isInApp) {
        const res = await (
          JSB.app.fetch({
            url: '/api/__APP_VERSION__/email/send_code',
            headers: JSON.stringify({
              'Content-Type': 'application/json',
            }),
            method: 'post',
            isInnerDomain: false,
            data: {
              email,
            },
          }) as any
        ).catch(() => ({ error_code: 2 }));

        if (!res || res.error_code !== 0) {
          throw new SubmitEmailError();
        }
      } else {
        const res = await fetch('/api/200/email/send_code', {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            email,
          },
          method: HttpMethod.post,
        }).catch(() => ({ error_code: 2 }));

        if (!res || res?.error_code !== 0) {
          throw new SubmitEmailError();
        }
      }
    },
    [isInApp],
  );

  return submitEmail;
}
